export default __webpack_public_path__ + "static/media/DIY-Tissue-Box.b970cf8f.jpg";